import React, { useState } from "react";
import {
  Typography,
  Box,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Paper,
  Stack,
  TextField,
  IconButton,
  CircularProgress,
  Container,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../Api/ApiUrls";
import { useNavigate } from 'react-router-dom';
import UserViewModal from "./UserViewModal";
import Carousel from 'react-material-ui-carousel';
import { styled } from '@mui/material/styles';
import DownloadIcon from "@mui/icons-material/Download";

const StyledCarousel = styled(Carousel)({
  width: '200px',
  height: '150px',
  borderRadius: '8px',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});

const UserPropertiesTable = ({ properties, loading, fetchProperties }) => {
  const [search, setSearch] = useState('');
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [currentProperty, setCurrentProperty] = useState(null);

  const navigate = useNavigate();

  const getImageUrl = (imagePath) => {
    return `${BASE_URL}${imagePath}`;
  };

  const handleDelete = async (property_id) => {
    if (window.confirm("Are you sure you want to delete this property?")) {
      try {
        await axios.delete(`${BASE_URL}/property/${property_id}/`);
        toast.success("Property deleted successfully");
        fetchProperties();
      } catch (error) {
        console.error("Error deleting property:", error);
        toast.error("Failed to delete property. Please try again.");
      }
    }
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };
  
const handleDownload = (imageUrl, filename) => {
  const link = document.createElement("a");
  link.href = imageUrl;
  link.setAttribute("download", filename); 
  link.setAttribute("target", "_blank"); // fallback if download fails
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


// const handleDownload = async (imageUrl, filename) => {
//   try {
//     const response = await fetch(imageUrl, { mode: "cors" });
//     const blob = await response.blob();
//     const url = window.URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = url;
//     link.download = filename; 
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     window.URL.revokeObjectURL(url);
//   } catch (error) {
//     console.error("Download failed:", error);
//   }
// };

  const handleViewClick = (property) => {
    setCurrentProperty(property);
    setViewModalOpen(true);
  };

  const filteredProperties = properties.filter(property => {
    const searchTerm = search.toLowerCase();
    const priceString = property.price?.toString() || '';
    const areaString = property.site_area?.toString() || '';
    
    return (
      property.property_name?.toLowerCase().includes(searchTerm) ||
      property.posted_by?.toLowerCase().includes(searchTerm) ||
      priceString.includes(searchTerm) ||
      areaString.includes(searchTerm)
    );
  });

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container sx={{ mt: 2 }}>
      <Box sx={{  mx: 'auto', p: 1, borderRadius: 2, boxShadow: 3, backgroundColor: '#fff', width: "128%", marginLeft: "-14%" }}>
        <TextField
          label="Search Properties"
          variant="outlined"
          value={search}
          onChange={handleSearchChange}
          placeholder="Search by name or location..."
          size="small"
          sx={{ width: 300, mb: 2 }}
        />
<TableContainer component={Paper} sx={{ maxHeight: 600 }}>
  <Table stickyHeader>
    <TableHead>
      <TableRow>
        {['S.No', 'Name', 'images','User Mobile', 'Posted By', 'Facing', 'Site Area', 'Price', 'Location', 'Actions'].map((head) => (
          <TableCell 
            key={head} 
            sx={{ 
              backgroundColor: '#1976d2', 
              color: 'white', 
              textAlign: 'center', 
              fontSize: 16,
            
              position: 'sticky',
              top: 0,
              zIndex: 1
            }}
          >
            <strong>{head}</strong>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>

    <TableBody>
      {filteredProperties.map((property, index) => (
        <TableRow key={property.property_id}>
          <TableCell sx={{ textAlign: 'center' }}>{index + 1}</TableCell>
          <TableCell sx={{ textAlign: 'center' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Typography>{property.property_name}</Typography>
            </Box>
          </TableCell>
<TableCell sx={{ textAlign: 'center' }}> 
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))', // flexible columns
      gap: 1.5,
      justifyItems: 'center',
      alignItems: 'center',
      maxWidth: 200,
      mx: 'auto'
    }}
  >
    {property.property_images && property.property_images.length > 0 ? (
      property.property_images.map((imageObj, i) => {
        const imageUrl = getImageUrl(imageObj.image);
        const filename = `property_${property.property_id}_image_${i + 1}.jpg`;

        return (
          <Box
            key={imageObj.id}
            sx={{
              position: 'relative',
              width: 80,
              height: 60,
            }}
          >
            <Box
              component="img"
              src={imageUrl}
              alt={property.property_name}
              onError={(e) => { e.target.src = 'https://via.placeholder.com/80x60'; }}
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: 1,
                border: '1px solid #ccc',
              }}
            />
            <IconButton
              size="small"
              sx={{
                position: 'absolute',
                top: 2,
                right: 2,
                backgroundColor: 'rgba(255,255,255,0.7)',
                '&:hover': { backgroundColor: 'white' },
                padding: 0.5,
              }}
              onClick={() => handleDownload(imageUrl, filename)}
            >
              <DownloadIcon sx={{ fontSize: 12 }} />
            </IconButton>
          </Box>
        );
      })
    ) : (
      <Typography variant="body2">No images</Typography>
    )}
  </Box>
</TableCell>



          <TableCell sx={{ textAlign: 'center' }}>{property.mobile_no}</TableCell>
          <TableCell sx={{ textAlign: 'center' }}>{property.posted_by}</TableCell>
          <TableCell sx={{ textAlign: 'center' }}>{property.facing}</TableCell>
          <TableCell sx={{ textAlign: 'center' }}>{property.site_area}</TableCell>
          <TableCell sx={{ textAlign: 'center' }}>{property.price}</TableCell>
          <TableCell sx={{ textAlign: 'center' }}>{property.location}</TableCell>
          
          <TableCell sx={{ textAlign: 'center' }}>
            <Stack direction="row" spacing={1} justifyContent="center">
              <IconButton color="info" onClick={() => handleViewClick(property)}>
                <VisibilityIcon />
              </IconButton>
              <IconButton color="error" onClick={() => handleDelete(property.property_id)}>
                <DeleteIcon />
              </IconButton>
            </Stack>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>

      </Box>

      <UserViewModal 
        open={viewModalOpen} 
        onClose={() => setViewModalOpen(false)} 
        property={currentProperty} 
      />
    </Container>
  );
};

export default UserPropertiesTable;